// extracted by mini-css-extract-plugin
export var active = "_qs-1";
export var circle = "_qs-0";
export var completed = "_qs-2";
export var connector = "_qs-4";
export var connectorCompleted = "_qs-7";
export var connectorSpacer = "_qs-5";
export var iconStrokeOverride = "_qs-8";
export var labelContainer = "_qs-6";
export var pending = "_qs-3";